<template>
  <div id="tryoutgroup-form">
    <ol class="breadcrumb pull-right">
      {{source ? '' : ''}}
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/video'}">Video Pembelajaran</router-link>
      </li>
      <li class="active">Upload</li>
    </ol>
    <!-- begin page-header -->
    <h1 class="page-header">Upload Video</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Upload Video Pembelajaran</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group" v-if="modul != null">
                  <label class="col-md-2 control-label">Modul Name *</label>
                  <div class="col-md-8 col-xs-12">
                      <input type="text" class="form-control" :value="modul.name" readonly>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">URL Video *</label>
                  <div class="col-md-8 col-xs-12">
                      <input type="text" class="form-control" placeholder="Masukkan URL Video dan tekan enter" v-on:keydown="hideForm()" required v-model="url">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label"></label>
                  <div class="col-md-8 col-xs-12">
                      <span v-if="changeUrl"></span>
                    <button v-if="changeUrl" type="button" class="btn btn-success pull-left mb-3" @click="checkURL()">Preview URL</button>
                    <youtube v-if="!changeUrl" :video-id="videoId" ref="youtube" @playing="playing"></youtube>
                    <!-- <button @click="playVideo">play</button> -->
                  </div>
                </div>
            <!-- SPECIALITY OF LIVE STREAM -->
                <div  v-if="$route.name === 'VideoMaterialLiveStream'">
                <div class="form-group">
                  <label class="col-md-2 control-label">Mulai</label>
                  <transition name="fade">
                    <div class="col-md-4 col-xs-12">
                      <div class="input-group">
                        <input id="startDate" v-model="start_date" type="text" class="form-control datepicker" name="start_date" readonly>
                        <span class="input-group-btn">
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </transition>
                  <div class="col-md-4 col-xs-12">
                    <div class="input-group clockpicker">
                      <input id="startTime" v-model="start_time" type="text" class="form-control" placeholder="Jam : Menit" name="start_time" readonly>
                      <span class="input-group-btn">
                        <button class="btn btn-success" type="button">
                          <i class="fa fa-clock-o"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Berakhir</label>
                  <transition name="fade">
                    <div class="col-md-4 col-xs-12">
                      <div class="input-group">
                        <input id="endDate" v-model="end_date" type="text" class="form-control datepicker" placeholder="Tanggal" name="end_date" readonly>
                        <span class="input-group-btn">
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </transition>
                  <div class="col-md-4 col-xs-12">
                    <div class="input-group clockpicker">
                      <input id="endTime" v-model="end_time" type="text" class="form-control" placeholder="Jam : Menit" name="end_time" readonly>
                      <span class="input-group-btn">
                        <button class="btn btn-success" type="button">
                          <i class="fa fa-clock-o"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                </div>
                <!-- END SPECIALITY LIVE STREAM -->
                <div v-if="!changeUrl">
                    <div class="form-group">
                        <label class="col-md-2 control-label">Source</label>
                        <div class="col-md-8 col-xs-12">
                            <select class="form-control" v-model="source">
                                <option value="youtube">Youtube</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Judul Video *</label>
                        <div class="col-md-8 col-xs-12">
                            <input type="text" class="form-control" :readonly="!$route.query.id && !$route.query.liveId" placeholder="Judul Video" v-model="judul">
                            <span v-if="!$route.query.id && !$route.query.liveId">
                                <input type="checkbox" name="alt-title" v-model="altTitle" value="Bike"> Judul Alternatif
                            </span>
                        </div>
                        <div class="offset-2 col-md-8 col-xs-12 pt-0" v-if="altTitle">
                            <input type="text" class="form-control" placeholder="Judul Alternatif" v-model="judulalt" :required="altTitle">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Jenjang *</label>
                        <div class="col-md-2 col-xs-2">
                            <select class="form-control" v-model="jenjang" @change="resetKelas()">
                                <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group" v-if="jenjang">
                        <label class="col-md-2 control-label">Kelas *</label>
                        <div class="col-md-2 col-xs-2">
                          <div v-if="jenjang === 'SD'">
                            <!-- <select class="form-control" v-model="kelas">
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select> -->
                            <span>
                              <input type="checkbox" value="1" v-model="kelas"/> &nbsp;1
                            </span>
                            <span>
                              <input type="checkbox" value="2" v-model="kelas"/> &nbsp;2
                            </span>
                            <span>
                              <input type="checkbox" value="3" v-model="kelas"/> &nbsp;3
                            </span>
                            <span>
                              <input type="checkbox" value="4" v-model="kelas"/> &nbsp;4
                            </span>
                            <span>
                              <input type="checkbox" value="5" v-model="kelas"/> &nbsp;5
                            </span>
                            <span>
                              <input type="checkbox" value="6" v-model="kelas"/> &nbsp;6
                            </span>
                          </div>
                          <div v-if="jenjang === 'SMP'">
                            <!-- <select class="form-control" v-model="kelas">
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                            </select> -->
                            <span>
                              <input type="checkbox" value="7" v-model="kelas"/> &nbsp;7
                            </span>
                            <span>
                              <input type="checkbox" value="8" v-model="kelas"/> &nbsp;8
                            </span>
                            <span>
                              <input type="checkbox" value="9" v-model="kelas"/> &nbsp;9
                            </span>
                          </div>
                          <div v-if="jenjang === 'SMA'">
                            <!-- <select class="form-control" v-model="kelas">
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select> -->
                            <span>
                              <input type="checkbox" value="10" v-model="kelas"/> &nbsp;10
                            </span>
                            <span>
                              <input type="checkbox" value="11" v-model="kelas"/>&nbsp; 11
                            </span>
                            <span>
                              <input type="checkbox" value="12" v-model="kelas"/> &nbsp;12
                            </span>
                          </div>
                        </div>
                        <div class="col-md-6 class-type" v-if="jenjang === 'SMA'">
                            <select class="form-control" v-model="interest">
                                <option value="SAINTEK">IPA</option>
                                <option value="SOSHUM">IPS</option>
                                <option value="ALL">Semua</option>
                            </select>
                            <!-- <span class="type">
                                <input type="checkbox" name="ipa" id="option1" value="SAINTEK" autocomplete="off" v-model="interest"> IPA
                            </span>
                            <span class="type">
                                <input type="checkbox" name="ips" id="option2" value="SOSHUM" autocomplete="off" v-model="interest"> IPS
                            </span> -->
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Mata Pelajaran *</label>
                        <div class="col-md-8 col-xs-12">
                             <select class="form-control" v-model="mapel">
                                <option v-for="item in mapelList" v-bind:key="item.id" :value="item.id">{{item.nama}}</option>
                            </select>
                        </div>
                    </div>
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right" v-if="!changeUrl">
                <button v-if="!$route.query.id && !$route.query.liveId" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
                <button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <app-modal v-if="showModal" :withCancel="true" v-on:ok="removeDependency()" v-on:cancel="showModal = false">
      <h4 slot="header">Hapus Pra-Syarat</h4>
      <div slot="body">Apakah anda yakin akan menghapus pra-syarat <strong style="color: red">{{dependencyName}}</strong> ?</div>
    </app-modal>
  </div>
</template>

<script>
import TryoutChooser from '@/components/tryout_group/TryoutChooser'
import TryoutGroupChooser from '@/components/tryout_group/TryoutGroupChooser'
import Spinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
import TryoutService from '@/services/tryout.js'
import moment from 'moment'
import axios from 'axios'
import ItembankService from '@/services/itembank.js'
import VideoService from '@/services/video.js'

export default {
  name: 'tryoutgroup-form',
  components: {
    'app-tryoutchooser': TryoutChooser,
    'app-tryoutgroupchooser': TryoutGroupChooser,
    'app-spinner': Spinner,
    'app-modal': Modal
  },
  data: function() {
    return {
      modul: null,
      isLoading: false,
      showModal: false,
      errors: [],
      videoId: null,
      judulalt: null,
      changeUrl: true,
      altTitle: false,
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1,2,3,4,5,6,7,8,9,10,11,12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      jenjang: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null,

    }
  },
  created(){
  },
  watch: {
    altTitle: function (val, oldval) {
      if (!val) {
        this.judulalt = this.judul
      }
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
    url: {
      get: function() {
        return this.$store.state.video.url
      },
      set: function(value) {
        this.$store.commit('video_set_url', value)
      }
    },
    judul: {
      get: function() {
        return this.$store.state.video.title
      },
      set: function(value) {
        this.$store.commit('video_set_title', value)
      }
    },
    kelas: {
      get: function() {
        return this.$store.state.video.grade
      },
      set: function(value) {
        this.$store.commit('video_set_grade', value)
      }
    },
    mapel: {
      get: function() {
        return this.$store.state.video.mapel
      },
      set: function(value) {
        this.$store.commit('video_set_mapel', value)
      }
    },
    interest: {
      get: function() {
        return this.$store.state.video.interest
      },
      set: function(value) {
        this.$store.commit('video_set_interest', value)
      }
    },
    description: {
      get: function() {
        return this.$store.state.video.description
      },
      set: function(value) {
        this.$store.commit('video_set_description', value)
      }
    },
    thumbnail: {
      get: function() {
        return this.$store.state.video.thumbnail
      },
      set: function(value) {
        this.$store.commit('video_set_thumbnail', value)
      }
    },
    source: {
      get: function() {
        return this.$store.state.video.source
      },
      set: function(value) {
        this.$store.commit('video_set_source', value)
      }
    },
    duration: {
      get: function() {
        return this.$store.state.video.duration
      },
      set: function(value) {
        this.$store.commit('video_set_duration', value)
      }
    }
  },
  methods: {
    playVideo() {
      this.player.playVideo()
    },
    playing() {
      console.log('\o/ we are watching!!!')
    },
    hideForm(){
      this.changeUrl = true
    },
    resetKelas() {
      this.kelas = []
      this.interest = 'ALL'
    },
    checkURL(){
      if(this.url){
        var context = this
        if(this.url.indexOf('embed') > -1){
          alert('video url tidak valid')
          return
        }else{
          this.videoId = this.url.substring(this.url.indexOf('=') + 1);
        }
        VideoService.getVideoDetail(this.videoId,function (response) {
          if (response.success) {
            context.changeUrl = false
            context.judul = response.data.title
            context.judulalt = response.data.title
            context.source = response.data.source
            context.thumbnail = response.data.thumbnail
            context.description = response.data.description
            context.duration = response.data.duration_in_sec
          } else {
            return
          }
        })
      } else {
        alert('URL diperlukan')
      }
    },
    validateForm: function() {
      this.errors = []
      if (this.judul == '') this.errors.push('Judul wajib diisi')
      if (this.source == '') this.errors.push('Source wajib diisi')
      if (this.kelas.length < 1) this.errors.push('Kelas wajib diisi')
      if (this.mapel == '') this.errors.push('Mata Pelajaran wajib diisi')
      if (this.judulalt == '') this.errors.push('Judul wajib diisi')
      if (this.kelas > 9 && this.interest == '') this.errors.push('Jurusan wajib diisi')
      if (this.kelas < 10) this.interest = 'ALL'
      return this.errors.length == 0
    },
    saveData: function() {
      if (!this.validateForm()) {
        return
      }
      if(this.$route.name === 'VideoMaterialLiveStream'){
        this.isLoading = true
        var context = this
        var body = {
            title: this.judulalt,
            description: this.description,
            interest: this.interest,
            source: this.source,
            youtube_url: this.url,
            grades: this.kelas,
            mapel_id: this.mapel,
            start_date: this.start_date,
            end_date: this.end_date,
            start_time: this.start_time,
            end_time: this.end_time,
            module_id: this.modul != null ? this.modul.id : null
        }
        VideoService.addVideoLiveStreaming( body, function(result) {
          context.isLoading = false
          context.$store.commit('video_reset', result.data)
          context.start_date = ''
          context.start_time = ''
          context.end_date = ''
          context.end_time = ''
          if (context.modul != null) context.$router.push({path: '/modul-belajar/live-stream', query: {modul_id: context.modul.id}})
          else context.$router.push({path: '/video'})
        })
      } else {
        this.isLoading = true
        var context = this
        var body = {
            title: this.judulalt,
            description: this.description,
            interest: this.interest,
            source: this.source,
            youtube_url: this.url,
            grades: this.kelas,
            mapel_id: this.mapel,
            duration: this.duration,
            thumbnail: this.thumbnail,
            module_id: this.modul != null ? this.modul.id : null
        }
        VideoService.addVideo( body, function(result) {
          context.isLoading = false
          context.$store.commit('video_reset', result.data)

          if (context.modul != null) context.$router.push({path: '/modul-belajar/materials', query: {modul_id: context.modul.id}})
          else context.$router.push({path: '/video'})
        })
      }
    },
    editData: function() {
      if (!this.validateForm()) {
        return
      }
    if(this.$route.name === 'VideoMaterialLiveStream'){
        this.isLoading = true
        var context = this
        var body = {
            title: this.$store.state.video.title,
            description: this.$store.state.video.description,
            interest: this.$store.state.video.interest,
            source: this.$store.state.video.source,
            youtube_url: this.$store.state.video.url,
            grades: this.$store.state.video.grade,
            mapel_id: this.$store.state.video.mapel,
            start_date: this.start_date,
            end_date: this.end_date,
            start_time: this.start_time,
            end_time: this.end_time,
            module_id: this.modul != null ? this.modul.id : null
        }
        VideoService.editVideoLiveStreaming(this.$route.query.liveId, body, function(result) {
          context.isLoading = false
          context.$store.commit('video_reset', result.data)
          context.start_date = ''
          context.start_time = ''
          context.end_date = ''
          context.end_time = ''
          if (context.modul != null) context.$router.push({path: '/modul-belajar/live-stream', query: {modul_id: context.$route.query.module}})
          else context.$router.push({path: '/video'})
        })
      } else {
        this.isLoading = true
        var context = this
        var body = {
            title: this.$store.state.video.title,
            description: this.$store.state.video.description,
            interest: this.$store.state.video.interest,
            source: this.$store.state.video.source,
            youtube_url: this.$store.state.video.url,
            grades: this.$store.state.video.grade,
            mapel_id: this.$store.state.video.mapel,
            duration: this.$store.state.video.duration,
            thumbnail: this.$store.state.video.thumbnail,
            module_id: this.modul != null ? this.modul.id : null
        }
        VideoService.editVideo( this.$route.query.id, body, function(result) {
          context.isLoading = false
          context.$store.commit('video_reset', result.data)
          // context.$router.push({path: '/video'})
          if(context.$route.name === 'VideoMaterial') {
            context.$router.push({path: '/modul-belajar/materials', query: {modul_id: context.$route.query.module}})
          } else {
            context.$router.push({path: '/video'})
          }
        })
      }
    },
  },
  mounted: function () {
    var context = this
    DatepickerPlugin.init("#startDate", function(value) {
      context.start_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    DatepickerPlugin.init("#endDate", function(value) {
      context.end_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    ClockpickerPlugin.init("#startTime", function(value) {
      context.start_time = value + ":00";
    })

    ClockpickerPlugin.init("#endTime", function(value) {
      context.end_time = value + ":00";
    })
    
    if(this.$route.query.id){
     var context = this
     this.changeUrl = false
     VideoService.getVideoDetailById( this.$route.query.id, function(result) {
        var gradeWrap = []
        var jenjangWrap = ''
        if (result.data.grades.length > 0) {
          for (var i =0; i < result.data.grades.length; i++) {
            gradeWrap.push(result.data.grades[i].grade)
            jenjangWrap = result.data.grades[i].jenjang.nama
          }
        }
        context.judul = result.data.title
        context.url = result.data.youtube_url
        context.jenjang = jenjangWrap
        context.kelas = gradeWrap
        context.source = result.data.source
        context.mapel = result.data.mapel.id
        context.interest = result.data.interest === 'OTHER' ? 'ALL' : result.data.interest
        context.duration = result.data.duration
        context.description = result.data.description
        context.videoId = result.data.youtube_url.substring(result.data.youtube_url.indexOf('=') + 1)
      })
    }

    if(this.$route.query.modul_id) {
      var modulId = this.$route.query.modul_id
      var context = this
      ItembankService.getModulBelajar(modulId, function (response) {
        if(response.success) {
          context.modul = response.data
        }
      })
    }

    if(this.$route.query.liveId) {
      var liveId = this.$route.query.liveId
      var context = this
      ItembankService.getLiveStream(liveId, function (result) {
        if(result.success) {
          context.changeUrl = false
          context.modul = {
            name: result.data.module.name
          }
          var gradeWrap = []
          var jenjangWrap = ''
          if (result.data.grades.length > 0) {
            for (var i =0; i < result.data.grades.length; i++) {
              gradeWrap.push(result.data.grades[i].grade)
              jenjangWrap = result.data.grades[i].jenjang.nama
            }
          }
          context.start_date = result.data.start_date
          context.start_time = result.data.start_time
          context.end_date = result.data.end_date
          context.end_time = result.data.end_time
          context.judul = result.data.title
          context.url = result.data.youtube_url
          context.jenjang = jenjangWrap
          context.kelas = gradeWrap
          context.source = result.data.source
          context.mapel = result.data.mapel.id
          context.interest = result.data.interest === 'OTHER' ? 'ALL' : result.data.interest
          context.duration = result.data.duration
          context.description = result.data.description
          context.videoId = result.data.youtube_url.substring(result.data.youtube_url.indexOf('=') + 1)
        }
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?1683be34